import { createFileRoute } from "@tanstack/react-router";

import { KeybindingsSettingsPanel } from "../components/settings/KeybindingsSettingsPanel";

export const Route = createFileRoute("/settings/keybindings")({
  component: KeybindingsSettingsPanel,
});
